import { jsxs as b, jsx as t } from "react/jsx-runtime";
import { c as o } from "./classnames-DLUjLwnh.js";
import "isomorphic-dompurify";
import "./deprecation-Hz1LRzMC.js";
const e = {
  gray: {
    soft: "bg-muted text-muted-foreground",
    solid: "bg-muted-foreground text-white",
    outline: "bg-transparent text-muted-foreground border border-border"
  },
  red: {
    soft: "bg-destructive/15 text-destructive",
    solid: "bg-destructive text-destructive-foreground",
    outline: "bg-transparent text-destructive border border-destructive/30"
  },
  green: {
    soft: "bg-success/15 text-success",
    solid: "bg-success text-success-foreground",
    outline: "bg-transparent text-success border border-success/30"
  },
  blue: {
    soft: "bg-primary/15 text-primary",
    solid: "bg-primary text-primary-foreground",
    outline: "bg-transparent text-primary border border-primary/30"
  },
  yellow: {
    soft: "bg-warning/15 text-warning",
    solid: "bg-warning text-warning-foreground",
    outline: "bg-transparent text-warning border border-warning/30"
  },
  purple: {
    soft: "bg-accent text-accent-foreground",
    solid: "bg-accent-foreground text-white",
    outline: "bg-transparent text-accent-foreground border border-accent-foreground/30"
  }
}, f = {
  ...e,
  // Aliases point to same styles
  default: e.gray,
  secondary: e.gray,
  destructive: e.red,
  success: e.green,
  warning: e.yellow,
  info: e.blue,
  outline: e.gray
}, r = {
  gray: "bg-muted-foreground",
  red: "bg-destructive",
  green: "bg-success",
  blue: "bg-primary",
  yellow: "bg-warning",
  purple: "bg-accent-foreground"
}, p = {
  ...r,
  default: r.gray,
  secondary: r.gray,
  destructive: r.red,
  success: r.green,
  warning: r.yellow,
  info: r.blue,
  outline: r.gray
}, m = {
  sm: "px-1.5 py-0.5 text-[10px]",
  md: "px-2.5 py-1 text-xs"
}, v = ({
  children: n,
  variant: s = "gray",
  size: a = "md",
  badgeStyle: d = "soft",
  uppercase: i = !1,
  dot: c = !1,
  removable: u = !1,
  onRemove: g,
  className: l
}) => /* @__PURE__ */ b(
  "span",
  {
    className: o(
      // Base styles - 2026 modern rounded with refined radius
      "inline-flex items-center gap-1.5 rounded-md font-semibold",
      // Size
      m[a],
      // Micro-typography for uppercase mode
      i && "uppercase tracking-wider",
      // Variant & style combination
      f[s][d],
      // Transition for interactive states
      "transition-colors duration-fast",
      l
    ),
    children: [
      c && /* @__PURE__ */ t(
        "span",
        {
          className: o(
            "h-1.5 w-1.5 rounded-full shrink-0",
            p[s]
          )
        }
      ),
      n,
      u && /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          onClick: g,
          className: o(
            "ml-0.5 -mr-0.5 h-3.5 w-3.5 rounded-sm flex items-center justify-center",
            "hover:bg-black/10 dark:hover:bg-white/10",
            "transition-colors duration-fast",
            "focus:outline-none focus:ring-1 focus:ring-current"
          ),
          children: /* @__PURE__ */ t("svg", { className: "h-2.5 w-2.5", fill: "none", viewBox: "0 0 10 10", stroke: "currentColor", strokeWidth: "2", children: /* @__PURE__ */ t("path", { d: "M2 2l6 6M8 2L2 8", strokeLinecap: "round" }) })
        }
      )
    ]
  }
);
export {
  v as B
};
